import { createFileRoute } from "@tanstack/react-router";
import { PcrContainer } from "../../app/views/pcr/pcrContainer";

export const Route = createFileRoute("/pcr")({
  component: PcrContainer,
});
